import {DataCollector} from "./DataCollector";
import {deepCopy} from "../../utils/deepCopy";
import {TokenRequest} from "../types/request/TokenRequest";
import {DataCollectorOptions} from "../types/SecurionPayOptions";
import {MerchantConfigLoader} from "../merchant-config/MerchantConfigLoader";
import {DataCollectorsMerchantConfig} from "../types/response/MerchantConfig";
import {KountDataCollector} from "./kount/KountDataCollector";
import {rejectOnTimeout} from "../../utils/timeoutPromise";


export class DataCollectorService {
    private readonly _dataCollectors: Promise<DataCollector[]>;

    constructor(options: DataCollectorOptions, merchantConfigLoader: MerchantConfigLoader) {
        if (options.dataCollectors) {
            this._dataCollectors = merchantConfigLoader.load()
                .then(config => this.createDataCollectors(config.dataCollectors || {}));
        } else {
            this._dataCollectors = Promise.resolve([])
        }
    }

    private createDataCollectors(config: DataCollectorsMerchantConfig): DataCollector[] {
        const result = []
        if (config.kount) {
            result.push(new KountDataCollector(config.kount))
        }
        return result;
    }

    public processTokenCreateRequest(inputRequest: TokenRequest): Promise<TokenRequest> {
        return this.processTokenRequest(inputRequest, 1000 * 10);
    }

    public fraudCheckAsTokenUpdate(): Promise<TokenRequest> {
        return this.processTokenRequest({}, 1000 * 20)
    }

    private processTokenRequest(inputRequest: TokenRequest, timeout: number): Promise<TokenRequest> {
        return this._dataCollectors.then(dataCollectors => {
            if (dataCollectors.length === 0) {
                return inputRequest;
            }
            const processedRequest = deepCopy(inputRequest);
            const allCollectorPromises = dataCollectors.map(collector => collector.processTokenRequest(processedRequest));
            return rejectOnTimeout(Promise.all(allCollectorPromises), timeout, "Data collection timed out").then(
                () => processedRequest,
                err => {
                    console.error("Some of data collectors failed to succeed", err)
                    return processedRequest
                }
            )
        })
    }
}